import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/configuration/company'
const RESOURCE_NAME_POLICY = '/policy'

export default {
  edit(configdata) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, configdata)
  },
  getConfig(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  editPolicy(configdata) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_POLICY}`, configdata)
  },
  getPolicy(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME_POLICY}/${id}`)
  },
}
